<template>
  <div class="row justify-content-md-center">
    <div class="col-12 form-group px-4 pt-3 pb-3 pb-sm-0">
      <label class="form-control-label">Inclusão de porcentagem sobre o volume da meta?</label><br>
      <div class="row justify-content-md-start">
        <div :class="{'col-6 col-md-6 col-xl-3 py-3': anosafra.copy_volume, 'col-3 py-3': !anosafra.copy_volume}">
          <base-checkbox
            :checked="anosafra.copy_volume"
            @input="$set(anosafra, 'copy_volume', !anosafra.copy_volume)"
          >
            sim
          </base-checkbox>
        </div>
        <div :class="{'col-6 col-xl-3 py-3': anosafra.copy_volume, 'col-3 py-3': !anosafra.copy_volume}">
          <base-checkbox
            :checked="!anosafra.copy_volume"
            @input="$set(anosafra, 'copy_volume', !anosafra.copy_volume)"
          >
            não
          </base-checkbox>
        </div>
        <div class="col-6 col-xl-3" v-if="anosafra.copy_volume">
          <base-input
            type="number"
            placeholder="Porcentagem sobre o volume da meta"
            v-model="anosafra.copy_volume_percentage"
            aria-label="Porcentagem sobre o volume da meta"
            append-icon="fa fa-percent"
            @input="HandleMessage()"
          />
          <div v-if="volumePercentageMessage" class="invalid-feedback text-justify mb-2 mt-n3" style="display: block;">
            {{ volumePercentageMessage }}
          </div>
        </div>
        <div class="col-6 col-md-6 col-xl-3" v-if="anosafra.copy_volume">
          <multiselect
            v-model="copy_volume_strategy"
            :options="percentageOptions"
            label="label"
            track-by="value"
            :allow-empty="false"
            select-label=""
            deselect-label=""
            placeholder="Selecionar"
          />
        </div>
      </div>
    </div>
    <div class="col-12 form-group px-4 pt-3 pb-3 pb-sm-0">
      <label class="form-control-label">Inclusão de porcentagem sobre o volume da meta estratégica?</label><br>
      <div class="row justify-content-md-start">
        <div class="col-3 py-3">
          <base-checkbox
            :checked="anosafra.copy_strategic_volume"
            @input="$set(anosafra, 'copy_strategic_volume', !anosafra.copy_strategic_volume)"
          >
            sim
          </base-checkbox>
        </div>
        <div class="col-3 py-3">
          <base-checkbox
            :checked="!anosafra.copy_strategic_volume"
            @input="$set(anosafra, 'copy_strategic_volume', !anosafra.copy_strategic_volume)"
          >
            não
          </base-checkbox>
        </div>
      </div>
    </div>
    <div
      v-if="anosafra.copy_strategic_volume" 
      class="col-12 form-group px-4 pt-3 pb-3 pb-sm-0" >
      <label class="form-control-label">Incluir a mesma porcentagem sobre todas as marcas?</label><br>
        <div class="row">
          <div class="col-3 py-3">
            <base-checkbox
              :checked="anosafra.samePercentageForAll"
              @input="changeSamePercegentageForAll"
            >
              sim
            </base-checkbox>
          </div>
          <div class="col-3 py-3">
            <base-checkbox
              :checked="!anosafra.samePercentageForAll"
              @input="changeSamePercegentageForAll"
            >
              não
            </base-checkbox>
          </div>
          <div class="col-6">
            <base-input
              v-model="anosafra.copy_strategic_volume_percentage"
              type="number"
              placeholder="Porcentagem sobre o volume da meta"
              aria-label="Porcentagem sobre o volume da meta"
              append-icon="fa fa-percent"
              @input="HandleMessage()"
            />
            <div v-if="strategicPercentageMessage" class="invalid-feedback text-justify mb-2 mt-n3" style="display: block;">
              {{ strategicPercentageMessage }}
            </div>
          </div>
        </div>
    </div>
    <anosafra-brand-percentages
      v-show="!anosafra.samePercentageForAll"
      v-model="anosafra.brand_copy_configurations_attributes"
    />
  </div>
</template>

<script>
import BaseCheckbox from "../Inputs/BaseCheckbox.vue";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import AnosafraBrandPercentages from '../../components/Anosafra/AnosafraBrandPercentages.vue';
import swal from 'sweetalert2';



export default {
  name: 'anosafra-percentages-form',
  props: {
    value: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    message: {
      type: String,
    }
  },
  emits: ['input'],
  components: {
    BaseCheckbox,
    Multiselect,
    AnosafraBrandPercentages
  },
  data: () => ({
    percentageOptions: [
      { value: 'add',    label: 'Acréscimo' },
      { value: 'remove', label: 'Decréscimo' },
    ],
    notifiedNotEditable: false,
    strategicPercentageMessage: "",
    volumePercentageMessage: "",
    validateVisualizeButton: true
  }),
  mounted() {
    this.setCopyVolumeStrategy()
    this.anosafra.samePercentageForAll = true;
  },
  watch: {
    'anosafra.copy_strategic_volume_percentage': function () {
      this.HandleMessage();
    },
    'anosafra.copy_volume_percentage': function () {
      this.HandleMessage();
    },
    'copy_volume_strategy': function () {
      this.HandleMessage()
    },
  },
  methods: {
    changeSamePercegentageForAll() {
      this.notifyEditableFields()
      this.$set(this.anosafra, 'samePercentageForAll', !this.anosafra.samePercentageForAll)
    },
    async notifyEditableFields() {
      if (this.notifiedNotEditable) return;

      this.notifiedNotEditable = true;

      const fireResult = await swal.fire({
        title: 'Deseja Continuar?',
        text: "Campos não editáveis, certifique-se que os valores informados estão corretos!",
        icon: 'warning',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'continuar',
      })

      if(!fireResult.isConfirmed){
        // TODO: tratar erro
        return
      }
    },
    setCopyVolumeStrategy() {
      this.copy_volume_strategy = this.percentageOptions[0]
    },
    HandleMessage() {
      const strategicPercentage = Number(this.anosafra.copy_strategic_volume_percentage) || 0;
      const volumePercentage = Number(this.anosafra.copy_volume_percentage) || 0;

      this.strategicPercentageMessage = "";
      this.volumePercentageMessage = ""
      this.validateVisualizeButton = true

      if (volumePercentage < 0 || volumePercentage > 100) {
        this.volumePercentageMessage = "A porcentagem deve ser válida (entre 0 e 100)."
        this.validateVisualizeButton = false
      }

       if (strategicPercentage < 0 || strategicPercentage > 100) {
         this.strategicPercentageMessage = "A porcentagem deve ser válida (entre 0 e 100)."
        this.validateVisualizeButton = false
      }

      if (this.copy_volume_strategy.value === "remove" && strategicPercentage > volumePercentage) {
        this.strategicPercentageMessage = "A porcentagem da meta estratégica não pode ser maior que a do volume de meta.";
        this.validateVisualizeButton = false
      } 

      this.$emit('update-validate-button', this.validateVisualizeButton);
    },
  },
  computed: {
    anosafra: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    copy_volume_strategy: {
      get() {
        return this.anosafra.copy_volume_strategy || this.percentageOptions[0]
      },
      set(value) {
        this.$set(this.anosafra, 'copy_volume_strategy', value)
      }
    },
    copy_strategic_volume_strategy: {
      get() {
        return this.anosafra.copy_strategic_volume_strategy || this.percentageOptions[0]
      },
      set(value) {
        this.$set(this.anosafra, 'copy_strategic_volume_strategy', value)
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.form-group {
  background-color: #e9ecef;
  border-radius: 10px;
}
</style>
